import OauthButtons from "@/src/components/auth/oauth-buttons";
import PasswordField from "@/src/components/auth/password-field.rhf";
import ScButton from "@/src/components/ui-kit/button";
import InputField from "@/src/components/ui-kit/input-field.rhf";
import { PASSWORD_LOGIN_ENABLED } from "@/src/constants/feature-flags";
import { useLogin } from "@/src/hooks/features/auth/use-login";
import { useTheme } from "@/src/styles/theme-provider";
import { useEffect, useRef } from "react";
import {
  Image,
  Pressable,
  ScrollView,
  Text,
  TextInput,
  View,
} from "react-native";
import Toast from "react-native-toast-message";

export default function LoginScreen() {
  const { varStyle } = useTheme();
  const {
    control,
    handleSubmit,
    errors,
    ssoStatus,
    rememberMe,
    isAuthenticating,
    isLoggingIn,
    onLogin,
    handleSSOError,
    navigateToForgotPassword,
    t,
  } = useLogin();

  const passwordRef = useRef<TextInput>(null);

  useEffect(() => {
    if (ssoStatus) {
      Toast.show({
        type: ssoStatus.type,
        text1: ssoStatus.message,
      });
    }
  }, [ssoStatus]);

  return (
    <View style={varStyle} className="flex-1 bg-chalk web:flex-row">
      {isAuthenticating && (
        <View className="absolute inset-0 z-50 bg-chalk/80 items-center justify-center">
          <Text className="text-primary font-bold text-lg">
            {t("LABEL_AUTHENTICATING")}
          </Text>
        </View>
      )}

      <View className="hidden xl:flex flex-1 items-end justify-center p-8">
        <Image
          source={require("../../../assets/images/auth.png")}
          className="w-full h-full max-w-xl"
          resizeMode="contain"
        />
      </View>

      <View className="flex-1 items-center justify-start web:px-6 py-4">
        <ScrollView
          className="w-full"
          contentContainerClassName="items-center justify-center min-h-full"
          showsVerticalScrollIndicator={false}
        >
          <View className="w-full max-w-lg px-4 py-0">
            <View className="bg-chalk p-6 web:rounded-xl web:border web:border-ash-3 web:p-5">
              <View className="flex-row justify-center items-center mt-6 mb-4 web:mt-6 web:mb-3">
                <Image
                  source={require("../../../assets/images/club_logo.png")}
                  style={{ width: 28, height: 28 }}
                  resizeMode="contain"
                />
                <Text className="ml-2 text-primary text-2xl font-bold">
                  {t("LABEL_SELISE_LOGO")}
                </Text>
              </View>

              <Text className="web:text-xl text-2xl font-bold text-center mb-2 web:mb-1 text-onyx">
                {t("LABEL_WELCOME")}
              </Text>
              <Text className="web:text-xs text-sm text-center text-slate mb-6 web:mb-4">
                {t("HINT_SIGN_IN")}
              </Text>

              {PASSWORD_LOGIN_ENABLED && (
                <>
                  <InputField
                    showLabel
                    label={t("LABEL_EMAIL")}
                    name="email"
                    control={control}
                    keyboardType="email-address"
                    autoComplete="username"
                    backgroundColor="bg-obsidian"
                    placeholder={t("LABEL_EMAIL_PLACEHOLDER")}
                    error={errors.email?.message}
                    returnKeyType="next"
                    blurOnSubmit={false}
                    onSubmitEditing={() => passwordRef.current?.focus()}
                  />

                  <PasswordField
                    ref={passwordRef}
                    label={t("LABEL_PASSWORD")}
                    control={control}
                    name="password"
                    autoComplete="current-password"
                    error={errors.password?.message}
                    returnKeyType="go"
                    onSubmitEditing={handleSubmit(onLogin)}
                  />

                  <View className="flex-row justify-end items-center mb-6 web:mb-4">
                    <Pressable onPress={navigateToForgotPassword}>
                      <Text className="text-primary underline web:text-xs text-sm font-semibold">
                        {t("QUEST_FORGOT_PASSWORD")}
                      </Text>
                    </Pressable>
                  </View>

                  <ScButton
                    text={isLoggingIn ? "LABEL_LOGGING_IN" : "BTN_LOGIN"}
                    onPress={handleSubmit(onLogin)}
                    disabled={isLoggingIn}
                    loading={isLoggingIn}
                    className="mb-6 h-16 web:h-10 web:mb-4 rounded-lg"
                  />
                </>
              )}

              <OauthButtons
                onSSOError={handleSSOError}
                rememberMe={rememberMe}
                dividerLabel={
                  PASSWORD_LOGIN_ENABLED ? undefined : "LABEL_SIGN_IN_WITH_ONLY"
                }
              />
            </View>

            <View className="mt-12 items-center mb-6 web:mt-4 web:mb-2">
              <Image
                source={require("../../../assets/images/selise_logo.png")}
                style={{ width: 100, height: 36 }}
                resizeMode="contain"
              />
            </View>
          </View>
        </ScrollView>
      </View>
    </View>
  );
}
